import { Switch } from "@mui/material";

import { customNameComparator } from "../../../../../helpers/coappDataGridUtils";
import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridListCell from "../../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";

export const roleUserColumns = ["actions", "user", "roles", "groups", "lastExtensionHeartbeat", "createdAt", "status"];

export const getRoleUsersColumns = (
	loading,
	organizationSsoStatus,
	navigationItemReferences,
	viewUserPage,
	roleId,
	stateName,
	removeUserFromRole,
	handleUserStatusToggle,
	currentUserIsCoAppSupport
) => [
	{
		editable: false,
		field: "user",
		valueGetter: (params) => params.value === "" ? "" : params,
		sortComparator: customNameComparator,
		flex: 1,
		headerName: "User",
		pinnable: false,
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} isUser={true} isCoAppSupport={params.row.isCoAppSupport} />}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "roles",
		sortable: false,
		flex: 1,
		headerName: "Roles",
		pinnable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridListCell items={params.value} resource="Roles" isCoAppSupport={params.row.isCoAppSupport} />}
				isLoading={loading}
			/>
		),
	},
	{
		disableColumnMenu: true,
		editable: false,
		field: "groups",
		filterable: false,
		flex: 1,
		headerName: "Groups",
		pinnable: false,
		sortable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridListCell items={params.value} resource="Groups" />}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "lastHeartbeat",
		width: 200,
		headerName: "Last heartbeat",
		pinnable: false,
		valueGetter: (params) => !params ? null : new Date(params),
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "createdAt",
		width: 200,
		headerName: "Created",
		pinnable: false,
		valueGetter: (params) => !params ? null : new Date(params),
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "active",
		width: 90,
		headerName: "Status",
		sortable: true,
		pinnable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<Switch
						checked={params.row.active}
						disabled={organizationSsoStatus || params.row.isCoAppSupport}
						onChange={() => handleUserStatusToggle(params.row.id, params.row.active === true ? "false" : "true")}
					/>
				}
			/>
		),
	},
	{
		field: "actions",
		flex: .1,
		sortable: false,
		type: "actions",
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellValue={params.value}
				cellToRender={
					<div>
						{
							organizationSsoStatus ?
								<ThreeDotMenu
									options={[
										{
											name: "View User",
											optionClickHandler: () => {
												viewUserPage(params, navigationItemReferences.roleNavItemIndex, roleId, stateName);
											},
										},
									]}
									isCoAppSupport={params.row.isCoAppSupport}
								/>
								:
								<ThreeDotMenu
									options={[
										...((!params.row.isCoAppSupport || currentUserIsCoAppSupport) ? [{
											name: "Remove From Role",
											optionClickHandler: () => {
												removeUserFromRole(params.row.id);
											},
										}] : []),
										{
											name: "View User",
											optionClickHandler: () => {
												viewUserPage(params, navigationItemReferences.roleNavItemIndex, roleId, stateName);
											},
										},
									]}
									isCoAppSupport={params.row.isCoAppSupport}
								/>
						}
					</div>
				}
				isLoading={loading}
			/>
		),
	}
];